import _actions_set from './_actions/set.js'
import _mutations_set from './_mutations/set.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        set: _mutations_set,
    },
    actions:{
        set: _actions_set,
    },
}